/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function($){    

  // Quick Help Section (beneath search)   
  
    var d = new Date();
    var weekday = new Array(7);
    weekday[0] = "Sunday";
    weekday[1] = "Monday";
    weekday[2] = "Tuesday";
    weekday[3] = "Wednesday";
    weekday[4] = "Thursday";
    weekday[5] = "Friday";
    weekday[6] = "Saturday";

    var currDay = weekday[d.getDay()];
    //console.log("Current day is " + n);

    var openText = "";

    if(currDay == "Monday" || currDay == "Tuesday" || currDay == "Wednesday" || currDay == "Thursday" || currDay == "Friday" ){
        openText = "Open today 8:00am – 4:00pm";
    }else{
        openText = "Closed Today";
    }

    $(".js-open-text").text(openText);

    /* ============================================================= */
    // Show/Hide full descriptions
    /* ============================================================= */

    $(".js-toggle-full-desc").click(function(e){
        e.preventDefault();

        var curr_btn = $(this);

        // Handle the full desc
        $(".page-desc-meta-output__full").toggle();

        // Handle the read more button
        curr_btn.text('');

        // Toggle a class
        curr_btn.toggleClass("js-toggle-full-desc--open");

        if(curr_btn.hasClass("js-toggle-full-desc--open")){
            curr_btn.text('Show Less');
        }else{
            curr_btn.text('Read More');
        }
    });

})(jQuery);  